import classNames from 'classnames';
import { DownArrow } from 'components/Icons';
import Tooltip from 'components/Tooltip';
import React from 'react';
import styles from './index.module.scss';
import type { ThProps } from './Th';
import { Th } from './Th';

export interface SortableThClickPayload<TField extends string> {
  action: string;
  field: TField;
  direction: 'asc' | 'desc';
}
export interface SortableThProps<TField extends string> extends Omit<ThProps, 'onClick'> {
  direction?: null | 'asc' | 'desc';
  field: TField;
  tooltip?: string | null | undefined;
  onClick: (payload: SortableThClickPayload<TField>) => void;
  onToggleBatch?: () => void;
}

export class SortableTh<TField extends string> extends React.PureComponent<
  SortableThProps<TField>
> {
  handleOnClick = (event: React.MouseEvent) => {
    const { field, direction } = this.props;
    const newDirection = (direction || 'desc') === 'desc' && this.props.isActive ? 'asc' : 'desc';
    if (this.props.onToggleBatch) {
      event.preventDefault();
      this.props.onClick({
        action: 'batchSelect',
        field,
        direction: newDirection,
      });
    } else {
      this.props.onClick({ action: 'sort', field, direction: newDirection });
    }
  };

  render() {
    const { children, className, isActive, field, direction, tooltip, ...rest } = this.props;
    const containerClass = classNames(styles.sortable, className);
    const sortClass = classNames(styles.sortIcon, styles[direction || 'desc']);
    return (
      <Th {...rest} className={containerClass} onClick={this.handleOnClick} isActive={isActive}>
        <span className={styles.sortIconPlaceholder} />
        {tooltip ? <Tooltip title={tooltip}>{children}</Tooltip> : children}
        <span className={sortClass}>
          <DownArrow />
        </span>
      </Th>
    );
  }
}
